<div
  data-at-power-limitation-status
  class="status-container flex flex-col gap-[16px] justify-start items-start"
>
  <div class="status-title">
    {{ headerLabel }}
  </div>
  <div class="flex flex-col gap-[8px] justify-start items-start">
    <div class="status-description">
      {{ powerLimitationStatus?.content?.longDescription | translate }}
    </div>
    <ng-container
      *ngIf="
        powerLimitationStatus.type === ACTIVE_ERROR_TYPE.SRC_DEVICE_OFFLINE;
        else powerLimitationDate
      "
    >
      <div class="date">{{ powerLimitationStatus?.editedAt | date: 'short' }}</div>
    </ng-container>
    <ng-template #powerLimitationDate>
      <div class="date">{{ powerLimitationStatus?.createdAt | date: 'short' }}</div>
    </ng-template>
  </div>
  <div class="buttons" *ngIf="powerLimitationStatus.type === ACTIVE_ERROR_TYPE.SRC_DEVICE_OFFLINE">
    <button
      *ngrxLet="uiService.isSingleRoomControlOverlayOpen$ as isSingleRoomControlOverlayOpen"
      gtm="onOpen"
      gtmAction="Show all added devices"
      gtmCategory="src"
      appSmallButton
      color="secondary"
      mat-stroked-button
      [class.disabled]="isSingleRoomControlOverlayOpen"
      [disabled]="isSingleRoomControlOverlayOpen"
      (click)="navigateToDevices()"
    >
      {{ 'GENERAL.BUTTON.DETAILS' | translate }}
    </button>
    <button
      class="status-anomaly__btn"
      gtm="onOpen"
      gtmAction="Show all added devices"
      gtmCategory="src"
      appSmallButton
      color="secondary"
      (click)="dismiss()"
      mat-stroked-button
    >
      {{ '+INSTALLATIONS.INSTALLATION.SMART_NOTE.DISMISS' | translate }}
    </button>
  </div>
</div>
